import { useMemo } from "react";
import { useAuth } from "../context/authContext";
import pageRoutes from "../data/pageRoutes";
import { ROUTES } from "../constants";
import { canAccessSettings, filterPageRoutesByAccess } from "../utilities/pageAccess";

const useAccessiblePages = () => {
	const { hasPermission, user } = useAuth();

	return useMemo(() => {
		return filterPageRoutesByAccess(pageRoutes, hasPermission, user).map((page) => {
			if (page.href === ROUTES.SETTINGS && canAccessSettings(user)) {
				return {
					...page,
					href: `${ROUTES.ADMIN}?tab=settings`,
				};
			}
			return page;
		});
	}, [hasPermission, user]);
};

export default useAccessiblePages;